import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MessageFolder } from '../updox-direct-message';

export type ActiveView = MessageFolder | 'contacts';

export interface FolderCount {
  inbox: number;
  draft: number;
  deleted: number;
}

@Component({
  selector: 'app-updox-folder-list',
  templateUrl: './folder-list.component.html',
})
export class UpdoxFolderListComponent {
  @Input() activeView: ActiveView = 'inbox';
  @Input() userAddress: string = '';
  @Input() counts: FolderCount = { inbox: 0, draft: 0, deleted: 0 };
  @Output() folderSelected = new EventEmitter<ActiveView>();
  @Output() newMessage = new EventEmitter<void>();

  select(view: ActiveView): void {
    this.folderSelected.emit(view);
  }
}
